/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";

import {
  Navbar,
  NavbarToggler,
  //NavbarText,
  Collapse,
  Nav,
  //NavItem,
  //NavLink,
} from "reactstrap";
import "../../../assets/css/Topnavbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { getAllStations } from "../../../store/actions/stationAction";
import { useDispatch, useSelector } from "react-redux";
import TopNavStationBtn from "./TopNavStationsBtn";
import { logout } from "../../../store/actions/authAction";

const TopNav = ({ active, setActive }) => {

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [isMenuOpen, setOpenMenu] = useState(false);

  useEffect(() => {
    dispatch(getAllStations());

    if (
      location.pathname === "/admin/dashboard" ||
      location.pathname === "/employee/dashboard"
    ) {
      setActive("live");
    }

    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setOpenMenu(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const userStations = useSelector(
    (state) => state?.authUser?.user?.data?.stations
  );

  // let userStationsObj = {};
  // userStations.forEach((element) => {
  //   if (!userStationsObj[element]) {
  //     userStationsObj[element] = element;
  //   }
  // });


  const logoutFunc = () => {
    dispatch(logout());
    dispatch({
      type: "LOG_OUT",
    });
    navigate("/", { replace: true });
  };

  const onMenuStationPressed = () => {
    setOpenMenu(!isMenuOpen);
  };

  return (
    <>
      <Navbar dark fixed="top" full className="header-top pt-0 pb-0">
        <div className="container-fluid d-flex align-items-center justify-content-between w-100">
          {/* Sinistra: Logo + bottoni iniziali */}
          <div className="d-flex align-items-center">
            {/* Logo */}
            <div className="logo-img mx-3">
              <img
                src="/img/operate-logo2.png"
                alt="Logo"
                className="img-responsive w-100 h-100"
                style={{ objectFit: "contain" }}
              />
            </div>

            {/* LIVE + RECIPE */}
            <div className="navbar-div navbar-bg">
              <TopNavStationBtn
                item="Live"
                index="Live"
                state="all"
                active={active}
                setActive={setActive}
              />
            </div>

            <div className="navbar-div navbar-bg d-md-none margin-left">
              <TopNavStationBtn
                item="Kellner"
                index="kel"
                path="tables"
                active={active}
                setActive={setActive}
              />
            </div>

            {location.pathname.includes("employee") && (
              <TopNavStationBtn
                item="RECIPIES"
                index="recipes"
                path="recipe-list"
                active={active}
                setActive={setActive}
              />
            )}
          </div>

          {/* Centro: Toggler visibile solo su mobile */}
          <NavbarToggler onClick={onMenuStationPressed} className="d-md-none" />

          {/* Destra: Solo su desktop */}
          <div className="d-none d-md-flex align-items-center ms-auto navbar-div navbar-bg">
            {userStations?.map((item, i) => (
              <TopNavStationBtn
                key={i}
                item={item}
                index={i}
                state={item}
                path="single-order"
                active={active}
                setActive={setActive}
              />
            ))}
          </div>

          <div className="d-none d-md-flex align-items-center ms-auto">
            <div className="d-flex">
              <div className="navbar-div navbar-bg">
                <TopNavStationBtn
                  item="Kellner"
                  index="kel"
                  path="tables"
                  active={active}
                  setActive={setActive}
                />
              </div>

              {/* <div className="navbar-div navbar-bg">
                <TopNavStationBtn
                  item="orderList"
                  index="all"
                  path="order-list"
                  state="all"
                  active={active}
                  setActive={setActive}
                  setHoverIcon={setHoverIcon}
                  hoverIcon={hoverIcon}
                  logo={
                    location.pathname.includes("employee")
                      ? "/img/icons/PROGR_BLACK.png"
                      : "/img/icons/ORDERLIST_BLACK.png"
                  }
                  logoActive={
                    location.pathname.includes("employee")
                      ? "/img/icons/PROGR_WHITE.png"
                      : "/img/icons/ORDERLIST_WHITE.png"
                  }
                />
              </div> */}

              <div className="navbar-div navbar-bg ms-1 me-1">
                <div
                  className="topCenter-btns text-uppercase"
                  onClick={() => logoutFunc()}
                >
                  <img
                    src="/img/icons/ic_logout.png"
                    alt="Logo"
                    className="mt-1"
                    height={25}
                    width={25}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile menu */}
        <Collapse isOpen={isMenuOpen} navbar className="d-md-none">
          <Nav className="ml-auto">
            <div className="menu-div w-100 m-2">
              {userStations?.map((item, i) => (
                <div className="menu-child-div w-100 my-2" key={i}>
                  <TopNavStationBtn
                    item={item}
                    index={i}
                    state={item}
                    path="single-order"
                    active={active}
                    setActive={setActive}
                    setOpenMenu={setOpenMenu}
                  />
                </div>
              ))}

              <div className="navbar-div navbar-bg ms-1 me-1">
                <div
                  className="topCenter-btns text-uppercase"
                  onClick={() => logoutFunc()}
                >
                  <span>Logout</span>
                </div>
              </div>
            </div>
          </Nav>
        </Collapse>
      </Navbar>
    </>
  );
};

export default TopNav;
